import { ReactElement } from 'react';
import { Grid } from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { useFormikContext } from 'formik';
import PmiTextField from 'shell/components/shared/text-field';
import { FitersCadastralVM } from 'system/pages/toponymy/circulation-area/list/types';

const FormFilter = (): ReactElement => {
  const formContext = useFormikContext<FitersCadastralVM>();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Foglio"
          label="Foglio"
          id="sheet"
          name="sheet"
          type="text"
          variant="outlined"
          value={formContext.values.sheet || ''}
          fullWidth
          onChange={formContext.handleChange}
          error={formContext.touched.sheet && Boolean(formContext.errors.sheet)}
          helperText={formContext.errors.sheet}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Particella"
          label="Particella"
          id="particle"
          name="particle"
          type="text"
          variant="outlined"
          value={formContext.values.particle || ''}
          fullWidth
          onChange={formContext.handleChange}
          error={formContext.touched.particle && Boolean(formContext.errors.particle)}
          helperText={formContext.errors.particle}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Subalterno"
          label="Subalterno"
          id="subordinate"
          name="subordinate"
          type="text"
          variant="outlined"
          value={formContext.values.subordinate || ''}
          fullWidth
          onChange={formContext.handleChange}
          error={formContext.touched.subordinate && Boolean(formContext.errors.subordinate)}
          helperText={formContext.errors.subordinate}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiButton variant="contained" color="secondary" type="submit">
          Cerca
        </PmiButton>
      </Grid>
    </Grid>
  );
};

FormFilter.displayName = 'Filters List Toponymy - Filter Cadastral - Form Filter component';

export default FormFilter;
